import { stringToCheck } from '@/utils/resultsHelper';
import {
  translatedError,
  checkRequired, checkExpression, checkMaxLength, checkNonNumeric,
} from '@/utils/errors';
import fieldNames from '@/constants/fields';
import { invalidSchemas } from './constants';

const nameSpaceFormatErrors = (errors, namespace, entity, title) => {
  const fields = [fieldNames.NAMESPACE];

  checkMaxLength(namespace, fields, errors, entity, title, 63);
  checkNonNumeric(namespace, fields, errors, entity, title);
  checkExpression(namespace, fields, errors, entity, title, /^[a-zA-Z_]/, 'schema.validation.start.letter');
  checkExpression(
    namespace,
    fields,
    errors,
    entity,
    title,
    /^[a-zA-Z_][a-zA-Z0-9_\- ]*$/,
    'schema.validation.invalid.characters',
  );

  if (invalidSchemas.reserved.includes(namespace)
    || invalidSchemas.prefixes.some((prefix) => namespace.startsWith(prefix))) {
    errors.push(translatedError(entity, title, 'schema.validation.reserved', fields));
  }
};

const nameSpaceErrors = (namespace, entity, title) => {
  const errors = [];
  const value = stringToCheck(namespace).toLowerCase();

  checkRequired(value, [fieldNames.NAMESPACE], errors, entity, title);
  if (errors.length === 0) {
    nameSpaceFormatErrors(errors, value, entity, title);
  }

  return errors;
};

export default nameSpaceErrors;
